// Types for control metrics API

export interface ControlMetricCandidate {
  name: string;
  metadata?: { display_name: string };
  version: number;
  dimension_filters?: Array<{
    dimension_filter_constraints: Array<{
      dimension_name: string;
      type: string;
      operator: string;
      values: (string | number)[];
    }>;
  }>;
  // Generated client-side to uniquely identify candidates with same name but different filters
  candidate_id?: string;
}

// Generate a unique candidate_id based on name and filters
export const generateCandidateId = (
  candidate: ControlMetricCandidate,
  index: number,
): string => {
  // Use index to ensure uniqueness even if name and filters are somehow identical
  const filterHash =
    candidate.dimension_filters
      ?.flatMap((df) =>
        df.dimension_filter_constraints.map(
          (c) => `${c.dimension_name}:${c.values.join(',')}`,
        ),
      )
      .join('|') || '';
  return `${candidate.name}__${filterHash}__${index}`;
};

// Get a human-readable filter summary for display
export const getFilterSummary = (candidate: ControlMetricCandidate): string => {
  const constraints =
    candidate.dimension_filters?.[0]?.dimension_filter_constraints || [];
  if (constraints.length === 0) return '';

  return constraints
    .map((c) => `${c.dimension_name}=${c.values.join(',')}`)
    .join(', ');
};

export interface ControlMetricCandidatesResponse {
  candidates: ControlMetricCandidate[];
}

export interface PrepopulatedFilterConstraint {
  dimension_name: string;
  operator: string;
  type: 'STRING' | 'INTEGER' | 'BOOLEAN';
  values: (string | number | boolean)[];
  source_facet: string;
  editable: boolean;
}

export interface PrepopulateResult {
  metric: string;
  dimension_filters: Array<{
    dimension_filter_constraints: PrepopulatedFilterConstraint[];
  }>;
  warnings: Array<{
    dimension_name: string;
    source_facet?: string;
    reason:
      | 'country_code_not_found'
      | 'dimension_not_found'
      | 'dimension_values_not_present'
      | 'dimension_value_type_mismatch';
  }>;
}

export interface PrepopulateFiltersResponse {
  results: PrepopulateResult[];
}

export interface PrepopulateFiltersRequest {
  metrics: string[];
  constraints: Array<{
    target: string;
    op: string;
    value: string;
  }>;
}
